import { Icon } from "@pepperstone/pepper-ui-kit";
import clsx from "clsx";
import type { ReactNode } from "react";
import styles from "./Drawer.module.css";
import { useClickAwayListener } from "./useClickAwayListener.ts";

export interface DrawerProps {
  title?: string;
  className?: string;
  children: ReactNode;
  onClose: () => void;
  showBackButton?: boolean;
  onBack?: () => void;
}

export default function Drawer({
  title,
  children,
  className,
  onClose,
  showBackButton = false,
  onBack,
}: DrawerProps) {
  const clickAwayRef = useClickAwayListener<HTMLDivElement>({
    handler: onClose,
  });

  return (
    <div className={clsx(styles.drawerOverlay, className)}>
      <div ref={clickAwayRef} className={styles.drawerContainer}>
        {title && (
          <div className={styles.drawerHeader}>
            <div className={styles.drawerHeaderContainer}>
              {showBackButton && onBack && (
                <button
                  type="button"
                  className={styles.backButton}
                  onClick={onBack}
                  aria-label="Back"
                >
                  <Icon icon="arrow-left" size={12} />
                </button>
              )}
              <h2 className={styles.drawerTitle}>{title}</h2>
            </div>
            <button
              type="button"
              className={styles.closeButton}
              onClick={onClose}
              aria-label="Close"
            >
              <Icon icon="cross" size={12} />
            </button>
          </div>
        )}
        {children}
      </div>
    </div>
  );
}
